import { render, staticRenderFns } from "./UnCategorized.vue?vue&type=template&id=1d61ef58"
import script from "./UnCategorized.vue?vue&type=script&lang=js"
export * from "./UnCategorized.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports